<template>
	<div class="message-tip">
		<Message myWidth="520px" myHeight="480px">
			<template v-slot:content>
				<div class="rules-wrap">
					<div class="text1">积分规则</div>
					<div class="text2">小宝驿站是将您闲置的带宽加入云计算，对于贡献闲置带宽的用户会获得积分奖励，积分可以兑换各类VIP会员卡，小宝驿站让您每日乐享收益。</div>
					<div class="text-wrap">
						<div class="text3 text-pre">开启小宝驿站不会影响您浏览网页、观看视频或网上购物的上网体验；</div>
						<div class="text3 text-pre" >积分奖励与上行带宽大小、闲置存储空间大小、每日设备在线时长、边缘</div>
						<div class="text3">计算调用所用带宽有关，具体获取积分数量以实际发放积分为准；</div>
						<div class="text3 text-pre">开启小宝驿站后24小时为资源部署期，若设备保持稳定运行，则会在</div>
						<div class="text3">开启小宝驿站的24小时后发放积分收益；</div>
						<div class="text3 text-pre">以上数据为实验环境下的理论数据，不代表对积分收益的承诺；</div>
						<div class="text3 text-pre">积分获取及兑换相关规则最终解释权归深圳市玩物科技所有。</div>
					</div>
					<div class="text4">若所有设置均正常但任无积分收益或积分收益较低时，请查阅 <a target="_blank" href="https://yc.ionewu.com/jdb_help/nat.html">《路由优化指引》</a></div>
					<div @click="showOrHideRulesTipClick()" class="confirm-btn">确定</div>
				</div>
			</template>
		</Message>
	</div>
</template>

<script>
import Message from "./Message.vue";

export default {
	components: {
		Message,
	},

	data: function () {
		return {
		};
	},
	methods: {
		showOrHideRulesTipClick: function () {
			//通知父组件
			let _that = this;
			_that.$emit("showOrHideRulesTipClick",'hide');
		},
	},
};
</script>

<style scoped lang="less">
.message-tip {
	.mixinBg{
		background-position: center;
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}
	.rules-wrap{
		padding-left: 41px;
		padding-right: 41px;
		padding-top: 28px;
		background-image: url("../assets/speedShare/a.png");
		background-position: bottom center;
		background-size: 100% 281px;
		background-repeat: no-repeat;
		height: 100%;
		box-sizing: border-box;

		.text1{
			.mixinBg();
			width: 100%;
			background-size: 100% 7px;
			background-image: url("../assets/speedShare/points_rules_title.svg");
			text-align: center;
			font-size: 20px;
			font-weight: 700;
			color: #21376C;
		}
		.text2,.text4{
			font-size: 14px;
			color: #1A1A1A;
			line-height: 24px;
		}
		.text2{
			margin-top: 30px;
		}
		.text4{
			margin-top: 20px;
			a{
				text-decoration: none;
				color: #21376C;
			}
		}
		.text-wrap{
			padding-top: 10px;
			padding-left: 11px;
			padding-right: 11px;
			font-size: 12px;
			line-height: 20px;
			color: #666666;

			.text3{
				position: relative;
				padding-left: 16px;
			}
			.text-pre{
				margin-top: 5px;
			}
			.text-pre::before{
				position: absolute;
				left: 0;
				top: 50%;
				transform: translate(0,-50%);
				content: '';
				width: 7px;
				height: 7px;
				border-radius: 50%;
				background-color: #144ECC;
			}
		}
		.confirm-btn{
			margin: 0 auto;
			margin-top: 25px;
			width: 112px;
			height: 36px;
			line-height: 36px;
			border-radius: 58px;
			background-color: #DBE5FB;
			color: #2460E0;
			text-align: center;
			font-size: 14px;
			cursor: pointer;
		}

	}
}
</style>
